import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiConstantsService } from './api-constants.service';
import {
  TaxProfile,
  TaxProfileCreationParams,
  TaxProfileListParams
} from '~core/models/core.models';
import { Pagination } from '~core/models/core.models';
import {
  Organization,
  OrganizationListParams
} from '~core/models/organization.models';

@Injectable()
export class TaxProfileService {
  private readonly _http = inject(HttpClient);
  private _apiConstantsService = inject(ApiConstantsService);

  list(params?: TaxProfileListParams): Observable<Pagination<TaxProfile>> {
    return this._http.get<Pagination<TaxProfile>>(
      this._apiConstantsService.taxProfilesUrl,
      {
        params: {
          ...params,
          sort: params?.sort || 'createdAt',
          desc: params?.desc || 'createdAt'
        } as Record<string, any>
      }
    );
  }

  read(id: string): Observable<TaxProfile> {
    return this._http.get<TaxProfile>(
      `${this._apiConstantsService.taxProfilesUrl}/${id}`
    );
  }

  create(payload: TaxProfileCreationParams): Observable<TaxProfile> {
    return this._http.post<TaxProfile>(
      this._apiConstantsService.taxProfilesUrl,
      {
        ...payload,
        useStateFormViolationHandler: true
      }
    );
  }

  update(
    id: string,
    payload: Partial<TaxProfileCreationParams>
  ): Observable<TaxProfile> {
    return this._http.put<TaxProfile>(
      `${this._apiConstantsService.taxProfilesUrl}/${id}`,
      { ...payload, useStateFormViolationHandler: true }
    );
  }

  delete(id: string): Observable<unknown> {
    return this._http.delete(
      `${this._apiConstantsService.taxProfilesUrl}/${id}`
    );
  }

  listOrganizations(
    id: string,
    params?: OrganizationListParams
  ): Observable<Pagination<Organization>> {
    return this._http.get<Pagination<Organization>>(
      `${this._apiConstantsService.taxProfilesUrl}/${id}/organizations`,
      {
        params: {
          ...params,
          sort: params?.sort || 'createdAt',
          desc: params?.desc || 'createdAt'
        } as Record<string, any>
      }
    );
  }

  linkOrganization(
    taxProfileId: string,
    organizationId: string
  ): Observable<unknown> {
    return this._http.post(
      `${this._apiConstantsService.taxProfilesUrl}/${taxProfileId}/attach/${organizationId}`,
      {}
    );
  }

  unlinkOrganization(
    taxProfileId: string,
    organizationId: string
  ): Observable<unknown> {
    return this._http.post(
      `${this._apiConstantsService.taxProfilesUrl}/${taxProfileId}/detach/${organizationId}`,
      {}
    );
  }
}
